// Little Ounce: экран с фильмом, перемотка видео прокруткой. Приём с svalto.com: один цикл requestAnimationFrame,
// перемотка только на новый кадр и только когда прошлая закончилась, цикл спит, пока секция вне экрана.
(function () {
  var root = document.querySelector('[data-lo-scrub]');
  if (!root || root.__lo) return;
  root.__lo = true;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window) || !window.requestAnimationFrame) return;

  var video = root.querySelector('video');
  var steps = [].slice.call(root.querySelectorAll('.lo-scrub__step'));
  var bar = root.querySelector('.lo-scrub__bar');
  var shade = root.querySelector('.lo-scrub__shade');
  var isDesk = window.matchMedia('(min-width: 900px)').matches;
  var FPS = 30, lastFrame = -1, inView = false, raf = 0, primed = false;

  var header = document.querySelector('header-component, .header, #header-group, header');
  if (header) root.style.setProperty('--lo-header', Math.min(header.getBoundingClientRect().height || 64, 120) + 'px');

  root.classList.add('lo-scrub--on');
  video.muted = true;
  video.src = isDesk ? root.dataset.filmD : root.dataset.filmM;
  video.preload = 'auto';

  // iOS не рисует кадр у видео, которое только перематывают: один раз запускаем и сразу ставим на паузу.
  function prime() {
    if (primed) return;
    try {
      var p = video.play();
      if (p && p.then) p.then(function () { video.pause(); primed = true; }, function () {});
      else { video.pause(); primed = true; }
    } catch (e) {}
  }
  video.addEventListener('loadeddata', function () { prime(); video.classList.add('is-ready'); lastFrame = -1; });
  ['touchstart', 'click', 'keydown'].forEach(function (ev) { window.addEventListener(ev, prime, { passive: true }); });

  function progress() {
    var r = root.getBoundingClientRect();
    var total = r.height - window.innerHeight;
    if (total <= 0) return 0;
    return Math.min(1, Math.max(0, -r.top / total));
  }
  function stepOpacity(p, s, e, first, last) {
    var f = 0.07;
    if (p < s || p > e) return (first && p <= s) || (last && p >= e) ? 1 : 0;
    var a = first && p < s + f ? 1 : Math.min(1, (p - s) / f);
    var b = last ? 1 : Math.min(1, (e - p) / f);
    return Math.max(0, Math.min(a, b));
  }
  function tick() {
    raf = 0;
    if (!inView) return;
    var p = progress();
    if (bar) bar.style.transform = 'scaleX(' + p + ')';
    if (shade) shade.style.opacity = p > 0.12 ? 1 : 0;
    steps.forEach(function (el, i) {
      var o = stepOpacity(p, parseFloat(el.dataset.s) || 0, parseFloat(el.dataset.e) || 1, i === 0, i === steps.length - 1);
      el.style.opacity = o;
      el.style.transform = 'translateY(' + (1 - o) * 14 + 'px)';
      el.style.pointerEvents = o > 0.5 ? 'auto' : 'none';
    });
    if (video.readyState >= 2 && video.duration && !video.seeking) {
      var frame = Math.round(p * (video.duration - 0.05) * FPS);
      if (frame !== lastFrame) { lastFrame = frame; video.currentTime = frame / FPS; }
    }
    raf = requestAnimationFrame(tick);
  }
  new IntersectionObserver(function (en) {
    inView = en[0].isIntersecting;
    if (inView && !raf) raf = requestAnimationFrame(tick);
  }, { rootMargin: '10% 0px' }).observe(root);
})();
